<template>
  <header class="mobile-header">
    <div class="header-bar">
      <div class="header-inner">
        <!-- 로고 -->
        <router-link to="/" class="logo">
          <span class="logo-title">힐스테이트 장안 센트럴 <span class="logo-badge">동대문</span></span>
        </router-link>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'MobileHeader'
}
</script>

<style scoped>
/* 헤더 바 */
.mobile-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
}

.header-bar {
  background: var(--primary, #961e1f);
  transition: background 0.3s ease;
}

.header-inner {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 로고 */
.logo {
  display: flex;
  align-items: center;
  text-decoration: none;
}

.logo-title {
  font-family: var(--font-family);
  font-size: 22px;
  font-weight: 700;
  color: #fff;
  letter-spacing: 1px;
}

.logo-badge {
  display: inline-block;
  background: #fff;
  color: var(--primary, #961e1f);
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 22px;
  font-weight: 700;
}

</style>
